import { useCallback, useState } from 'react';
import { faCheckCircle, faSignature } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from '@s20/i18n';
import { Alert } from '../../Modal';
import { FormLabel, StyledButton } from '../FormElements';
import { SignatureModal } from './SignatureModal';
import './index.scss';

export const SignatureButton = ({
    id, onSigSavedCallback, signatureLabel, sigData, reviewId,
}) => {
    const { t } = useTranslation();
    const [isValid, setIsValid] = useState(false);

    const validSigId = `validSignature_${id}`;

    const handleSignatureButtonClick = useCallback(() => {
        Alert.show({
            body: (
                <SignatureModal
                    id={id}
                    sigData={sigData}
                    reviewId={reviewId}
                    onSigSavedCallback={(e) => {
                        setIsValid(true);
                        onSigSavedCallback(e);
                    }}
                />
            ),
        });
    }, [id, onSigSavedCallback, sigData, reviewId]);

    return (
        <div>
            <div className="form-group">
                <FormLabel
                    for={validSigId}
                    label={t('timesheet:signatureColon')}
                    required
                />

                <StyledButton
                    color={!isValid ? 'primary' : 'success'}
                    onClick={handleSignatureButtonClick}
                    startIcon={isValid ? faCheckCircle : faSignature}
                    outlined={!isValid}
                >
                    {!!signatureLabel && <span className="mr-1">{signatureLabel}</span>}
                    {t('timesheet:signature')}
                </StyledButton>

                <input
                    id={validSigId}
                    type="text"
                    className="hidden-input-validation"
                    defaultValue={isValid ? 'true' : ''}
                    required
                />

                <small className="invalid-feedback text-danger w-100 text-right">
                    <b>{t('common:errorPrefix')}&nbsp;</b>
                    {t('timesheet:signatureRequired')}
                </small>
            </div>
        </div>
    );
};

export default SignatureButton;
